import React from 'react'
import { ColumnBib, ColumnName, ColumnNoc, ColumnExpander, ColumnRecords } from "components/common/TableColumns"
import { findArray } from 'helpers/utils'
import { ColumnRank } from 'components/common/TableColumns'
import { getCell } from './ColumnsRaceAnalisisLive'
import SportCode from 'components/common/SportCode'
import { ColumnWarnings } from "components/sports/ath/race_road/results/ColumnsLive"
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";



export function TableColumns(columnsAdded) {
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let numCols = findArray(columnsAdded, { ei_code: ['INTERMEDIATES_TOTAL'] });

    //Create Columns splits
    let columnsExt = columnsAdded.filter(row => row.ei_code === 'INTERMEDIATE').map((val) => {
        return (
            {
                Header: val.ei_value,
                accessor: (props) => (
                    props?.extendedResults?.filter(row => row.er_code === 'INTERMEDIATE' && row.er_pos === val.ei_pos).length > 0
                        ? Number(props.extendedResults.filter(row => row.er_code === 'INTERMEDIATE' && row.er_pos === val.ei_pos).map((val) => { return val.er_sortorder }))
                        : null
                ),
                sortType: "absoluteOrderNumber",
                disableSortBy: false,
                isVisible: false,
                columnIndex: val.ei_pos,
                id: 'ResultEx' + val.ei_pos,
                className: 'text-center',
                headerClassName: 'text-center w-15',
                Cell: (props) => {
                    let datarow = props?.cell?.row?.original;
                    let intermediates = datarow?.extendedResults?.filter(row => row.er_code === 'INTERMEDIATE' && row.er_pos === val.ei_pos);
                    let res = ""
                    if (intermediates?.length > 0) {
                        res = intermediates.map((val) => (getCell(val)))
                    }
                    else if (val.ei_pos === datarow?.finalSplit) {
                        res = <SportCode code={datarow.resultIrm} discipline={mirs_discipline} entity="@IRM" abbr={true} />
                    }
                    return (res);
                }
            }
        )
    })

    return (
        [
            ColumnRank({}),
            ColumnBib({}),
            ColumnNoc({}),
            ColumnName({}),
            ...columnsExt,
            ColumnWarnings({}),
            ColumnRecords({}),
        ]
    )
}

export default TableColumns
